class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.mobtoggleAddButton(true, "", false);
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.mobtoggleAddButton(true, "", true);
      this.setUnavailable();
      this.mobsetUnavailable();
      $(".cart-button-option").hide();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
      $(".cart-button-option").show();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    // if (this.currentVariant) {
    //   var variant_currentID = this.currentVariant.title;
    //   $(".cart-button-option").text(variant_currentID);
    // }

    if (this.currentVariant) {
      var variantCurrentID = this.currentVariant.title;
      if (variantCurrentID === 'Extra Extra Small') {
        variantCurrentID = 'XXS';
      } else if (variantCurrentID === 'Extra Small') {
        variantCurrentID = 'XS';
      } else if (variantCurrentID === 'Small') {
        variantCurrentID = 'S';
      } else if (variantCurrentID === 'Medium') {
        variantCurrentID = 'M';
      } else if (variantCurrentID === 'Large') {
        variantCurrentID = 'L';
      } else if (variantCurrentID === 'Extra Large') {
        variantCurrentID = 'XL';
      } else if (variantCurrentID === 'Extra Extra Large') {
        variantCurrentID = 'XXL';
      } else if (variantCurrentID === 'Extra Extra Extra Large') {
        variantCurrentID = 'XXXL';
      }else{
        variantCurrentID = this.currentVariant.title;
      }
      $('.cart-button-option').text(variantCurrentID);
    }
    
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if (document.querySelector(".media-thumb")) {
      document
        .querySelectorAll(".media-thumb .media-grid-column")
        .forEach(function (e) {
          var mediaid = e.dataset.id;
          if (mediaid == fetured_id) {
            new Swiper(".media-nav").slideTo(e.dataset.index, 1000, false);
          }
        });
    }
  }
  updateURL() {
    var img_type = $(".image-type").data("type");
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?view=${img_type}&variant=${this.currentVariant.id}`
    );
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-formmob-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".option-wrap"));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function (eachfield) {
      var checked_gender = eachfield.querySelector("input:checked");
      if (checked_gender) {
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if (option_count >= fieldlen) {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      }
    });
    if (option_count >= fieldlen) {
      $(".choose-cart").removeClass("hide-selectore-button");
      $(".choose-selector").addClass("hide-selectore-button");
      $(".mob-cartbtn").removeClass("hide-mob-cartbtn");
      $(".mob-choosesize").addClass("hide-mob-choosesize");
      $(".mobile-sticky-product").addClass("exist_variant");
      $(".product__pickup-availabilities").attr("data-variant", true);
    } else {
      $(".choose-cart").addClass("hide-selectore-button");
      $(".choose-selector").removeClass("hide-selectore-button");
      $(".mob-cartbtn").addClass("hide-mob-cartbtn");
      $(".mob-choosesize").removeClass("hide-mob-choosesize");
      $(".mobile-sticky-product").removeClass("exist_variant");
      $(".product__pickup-availabilities").attr("data-variant", false);
    }
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (this.currentVariant) {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
          this.mobtoggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > .cart-label');

      var soldOutTexts = document.querySelectorAll(".sold-out-text");
      var productAddCartButtons = document.querySelectorAll(".product-addcart");
      var soldOutButtons = document.querySelectorAll(".sold-out-btn");
      var infoButton = document.querySelectorAll(".mobile-pro-info .info");
      
      if (this.currentVariant !== undefined) {
        if (!this.currentVariant.available) {
          setTimeout(() => {
            soldOutTexts.forEach((btn) => btn.classList.remove('hide'));
            soldOutButtons.forEach((btn) => btn.classList.remove('hide'));
            infoButton.forEach((btn) => btn.classList.remove('opa'));
            productAddCartButtons.forEach((btn) => btn.style.display = 'none');
          }, 0);
        } else {
          setTimeout(() => {
            soldOutTexts.forEach((btn) => btn.classList.add('hide'));
            soldOutButtons.forEach((btn) => btn.classList.add('hide'));
            infoButton.forEach((btn) => btn.classList.add('opa'));
            productAddCartButtons.forEach((btn) => btn.style.display = 'block');
          }, 0);
        }
      }
    
    if (!addButton) return;
    if (disable) {
      //text = window.variantStrings.soldOut;
      //addButton.setAttribute('disabled', 'disabled');
      $('[name="add"]').attr("disabled", "disabled");
      //if (text) addButtonText.textContent = text;
      if (text) {
        $(".cart-label").text(text);
      }
    } else {
      $('[name="add"]').removeAttr("disabled");
      //addButton.removeAttribute('disabled');
      //addButtonText.textContent = window.variantStrings.addToCart;
      $(".cart-label").text($(".cart-label").data("label"));
    }
    if (!modifyClass) return;
  }
  mobtoggleAddButton(disable = true, text, modifyClass = true) {
    const m_productForm = document.getElementById(
      `product-formmob-${this.dataset.section}`
    );
    if (!m_productForm) return;
    const m_addButton = m_productForm.querySelector('[name="add"]');
    const mm_addButtonText = m_productForm.querySelector(
      '[name="add"] > .cart-label'
    );
    if (!m_addButton) return;
    if (disable) {
      m_addButton.setAttribute("disabled", "disabled");
      if (text) mm_addButtonText.textContent = text;
    } else {
      m_addButton.removeAttribute("disabled");
      //mm_addButtonText.textContent = window.variantStrings.addToCart;
      $(".cart-label").text($(".cart-label").data("label"));
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > .cart-label');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  mobsetUnavailable() {
    const button = document.getElementById(
      `product-formmob-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > .cart-label');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-radios", VariantRadios);
function variant_drodown() {
  if (document.querySelector(".dropdown-wrap")) {
    document.querySelectorAll(".dropdown-wrap").forEach(function (dropdown) {
      dropdown
        .querySelector(".variant-dropdown")
        .addEventListener("click", function (event) {
          event.preventDefault();
          dropdown.classList.toggle("active");
          dropdown
            .querySelectorAll('input[type="radio"]')
            .forEach(function (e) {
              e.addEventListener("change", function (button) {
                dropdown.classList.remove("active");
                dropdown.querySelector(".variant-dropdown").innerHTML =
                  button.path[0].value;
              });
            });
        });
    });
  }
}
document.querySelectorAll(".product-addcart").forEach(function (cartbutton) {
  cartbutton.addEventListener("click", function (evt) {
    evt.preventDefault();
    // $("html, body").animate({ scrollTop: "0" });
    //$('body').removeClass('mob-open-size');
    //$('.sp-bottom-variants').slideUp();
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    var cartform = cartbutton.closest("form");
    const formData = new FormData(cartform);
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          $(".cart-added").addClass("active");
          document.querySelector(".blackbar-error").innerHTML =
            response.description;
          $(".blackbar-error").show();
          $(".blackbar-text").hide();
          setTimeout(function () {
            $(".cart-added").removeClass("active");
          }, 4000);
          return;
        } else {
          if (typeof load_cart == "function") {
            load_cart();
            setTimeout(function (e) {
              $(".cart-added").addClass("active");
              $(".blackbar-error").hide();
              $(".blackbar-text").show();
              setTimeout(function () {
                $(".cart-added").removeClass("active");
              }, 4000);
            }, 500);
          } else {
            window.location.href = "/cart";
          }
        }
        //$('.sp-bottom-variants').slideUp(500);
        closesizemob();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
  });
});
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
variant_drodown();
document.addEventListener("shopify:section:load", function (event) {
  variant_drodown();
});
function getElementY(query) {
  return (
    window.pageYOffset +
    document.querySelector(query).getBoundingClientRect().top
  );
}
function doScrolling(element, duration) {
  var startingY = window.pageYOffset;
  var elementY = getElementY(element);
  var targetY =
    document.body.scrollHeight - elementY < window.innerHeight
      ? document.body.scrollHeight - window.innerHeight
      : elementY;
  var diff = targetY - startingY;
  var easing = function (t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  };
  var start;
  if (!diff) return;
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    var time = timestamp - start;
    var percent = Math.min(time / duration, 1);
    percent = easing(percent);
    window.scrollTo(0, startingY + diff * percent);
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  });
}
if (document.querySelector(".choose-selector")) {
  if (window.innerWidth < 641) {
    document
      .querySelector(".choose-selector a")
      .addEventListener(
        "click",
        doScrolling.bind(null, "#product-form-installment", 2000)
      );
  }
}
// $(document).on("click", ".selected-variant", function (e) {
//   e.preventDefault();
//   var data_option = $(this).attr("data-option");
//   $('.option-wrap[data-option="' + data_option + '"]')
//     .addClass("active")
//     .siblings()
//     .removeClass("active");
//   $("body").addClass("open-selector");
//   $(".blackbar").removeClass("active");
// });
// $(document).on("click", ".option-close,.overlay-boxinr", function (e) {
//   e.preventDefault();
//   $(".option-wrap").removeClass("active");
//   $("body").removeClass("open-selector");
//   $(".variant--list li").removeClass("active");
// });
jQuery(document).on("keyup", function (evt) {
  if (evt.keyCode == 27) {
    $(".option-wrap").removeClass("active");
    $("body").removeClass("open-selector");
  }
});
$('.variant--list li input[type="radio"]').on("change", function (e) {
  var current_selected = $(this).val();
  var current_option = $(this).closest(".option-wrap").data("option");
  $(
    '.selected-variant[data-option="' + current_option + '"] .d-option-name'
  ).text(current_selected);
  $(this).closest("li").addClass("active").siblings().removeClass("active");
});
$(".variant--list li").on("click", function (e) {
  $(this).closest("li").addClass("active").siblings().removeClass("active");
});
$(".variant--list li:not(.soldout-variantlist)").on("click", function (e) {
  setTimeout(function () {
    $(".option-wrap").removeClass("active");
    $("body").removeClass("open-selector");
    // $(".variant--list li").removeClass("active");
  }, 500);
});
$(".product-usp-slider").flickity({
  contsin: true,
  pageDots: true,
  initialIndex: 1,
  accessibility: true,
  autoPlay: 3000,
  wrapAround: true,
});
$(document).on("click", ".close-blackbar", function (e) {
  $(".blackbar").removeClass("active");
  return false;
});
$(document).on("click", ".cart-added a", function (e) {
  e.preventDefault();
  $("body").addClass("open-drawer");
});
$(window).on("load", function (e) {
  var pdpsticky_position =
    $(".section-blank-pdp").offset().top - $(window).height();
  var mobpdpsticky_position =
    $(".mobile-product-info").offset().top - $(window).height() / 2;
  if ($(window).width() > 991) {
    var wisndowscroll = $(window).scrollTop();
    if (wisndowscroll > pdpsticky_position) {
      $(".template-product").addClass("addSticky");
    } else {
      $(".template-product").removeClass("addSticky");
    }
    $(window).scroll(function () {
      var wisndowscroll = $(window).scrollTop();
      if (wisndowscroll > pdpsticky_position) {
        $(".template-product").addClass("addSticky");
      } else {
        $(".template-product").removeClass("addSticky");
      }
    });
  } else {
    var wisndowscroll = $(window).scrollTop();
    if (wisndowscroll > mobpdpsticky_position) {
      $(".template-product").addClass("addSticky");
    } else {
      $(".template-product").removeClass("addSticky");
    }
    $(window).scroll(function () {
      var wisndowscroll = $(window).scrollTop();
      if (wisndowscroll > mobpdpsticky_position) {
        $(".template-product").addClass("addSticky");
      } else {
        $(".template-product").removeClass("addSticky");
      }
    });
  }
});
$(window).on('scroll', function () {
  // var cur_pos = $(this).scrollTop();
  // $('.promedialist > div').each(function() {
  //   var top = $(this).offset().top-($(window).height()/2),
  //       bottom = top + $(this).outerHeight();
  //   if (cur_pos >= top && cur_pos <= bottom) {
  //     $('.product-dots li').removeClass('active');
  //     $('.promedialist > div').removeClass('active');
  //     $(this).addClass('active');
  //     $('.product-dots [data-count="'+$(this).data('count')+'"]').addClass('active');
  //   }
  // });
  var docViewTop = $(window).scrollTop();  
  var elemTop = $('.mobile-product-info').offset().top;
  var stickybottom_height = $('.stickytoppdpd').outerHeight()-$('.section-header').outerHeight();

  const sectionHeader = document.querySelector('.section-header');
  const mobileStickyProduct = document.querySelector('.mobile-sticky-product');

    const sectionHeaderBottom = sectionHeader.getBoundingClientRect().bottom;
    const mobileStickyProductTop = mobileStickyProduct.getBoundingClientRect().top;
    const availableHeight = mobileStickyProductTop - sectionHeaderBottom;

  var adjustedWindowHeight = availableHeight;
  // var adjustedWindowHeight = $(window).height() * 0.75;
  var docViewBottom = docViewTop + adjustedWindowHeight - stickybottom_height;
  var secondpart = $('.snippet-addto-cart').offset().top + adjustedWindowHeight;
  if(elemTop < docViewBottom && secondpart > docViewBottom){    
    $('.template-product').addClass('mob-pdp-stikcy'); 
    $('body').addClass('nonstickysize');
  }else{
    $('.template-product').removeClass('mob-pdp-stikcy');
    $('body').removeClass('nonstickysize');
    var recommedation = $('.mob-product-accordian').offset().top;
    if(recommedation<docViewBottom){
      $('.template-product').addClass('mob-pdp-stikcy');
      $('body').addClass('nonstickysize');
    }else{
      $('.template-product').removeClass('mob-pdp-stikcy');
      $('body').removeClass('nonstickysize');
    }
  }
});
$(window).on('load',function(e){
  const sectionHeader = document.querySelector('.section-header');
  const mobileStickyProduct = document.querySelector('.mobile-sticky-product');

    const sectionHeaderBottom = sectionHeader.getBoundingClientRect().bottom;
    const mobileStickyProductTop = mobileStickyProduct.getBoundingClientRect().top;
    const availableHeight = mobileStickyProductTop - sectionHeaderBottom;
  // var docViewTop = $(window).scrollTop() + $(window).height() * 0.75; // Adjust for 75vh
  var docViewTop = $(window).scrollTop() + availableHeight; // Adjust for 75vh
  var elemTop = $('.mobile-product-info').offset().top;
  if(elemTop < docViewTop){
    $('.template-product').addClass('mob-pdp-stikcy');  
  }else{
    $('.template-product').removeClass('mob-pdp-stikcy');    
  }
});

// ====================

if (screen.width > 992) {
   $(document).on('click','.zoombutton,.zoom-close,.pdpzoomicon,.promedialist .pro-medialoop',function(e){
  //e.preventDefault();
    $('body').addClass('zoom-active');
  });
}
$(document).on('click', '.mobile-screen-zoom', function(e) {
  $('body').addClass('zoom-active');
  var selectedElement = $('.pro-medialoop.is-selected');
  var zoomCount = selectedElement.data('zoom');
  $('.swiper-slide').hide();
  $('.swiper-slide[data-zoom="' + zoomCount + '"]').show();
})

$(document).on('click','.zoom-close',function(e){
   $('body').removeClass('zoom-active');
   $('.mySwiper .swiper-slide.swiper-slide-active').css('transform','none');
  $('.p-hide').show();
  $('.p-show').hide();
  $('.plus-icon svg').css('opacity','1');
});

// $('.plus-icon').on('click',function(e){
//   $('.mySwiper .swiper-slide.swiper-slide-active').css('transform','scale(1.5)');
//   $('.p-hide').hide();
//   $('.p-show').show();
//   $('.plus-icon svg').css('opacity','0.5');
// });

// $('.minus-icon').on('click',function(e){
//   $('.mySwiper .swiper-slide.swiper-slide-active').css('transform','none');
//   $('.p-hide').show();
//   $('.p-show').hide();
//   $('.plus-icon svg').css('opacity','1');
// });

// =========================



$(".variant--list li").on("click", function (e) {
  var currentupdate = $(this).find(".label-almost").text();
  if (currentupdate) {
    $(".current-update").text(currentupdate);
  } else {
    $(".current-update").text("");
  }
});
$(".mob-choosebtn").on("click", function (e) {
  e.preventDefault();
  $(".template-product").removeClass("mob-pdp-stikcy");
  $(".m-choose-selector a").trigger("click");
  //$("html, body").animate({ scrollTop: "0" });
});
$(document).on("click", ".addSticky .mob-choosebtn", function () {
  //$('body').addClass('nonstickysize');
});
$(document).on("click", ".nonstickysize .pdp-msticky-overlay", function (e) {
  e.preventDefault();
  $(".template-product").addClass("mob-pdp-stikcy");
});
// $('.product-dots li').on('click', function () {
//   var currencount = $(this).data('count');
//   $(this).addClass('active').siblings().removeClass('active');
//   $('html, body').animate({
//     scrollTop: $('[data-count="'+currencount+'"]').offset().top
//   }, 500);
//   return false;
// });
function swymCallbackFn(swat) {
  swat.evtLayer.addEventListener(
    swat.JSEvents.addedToWishlist,
    function (event) {
      $(".wishlistbar").addClass("active");
      setTimeout(function () {
        $(".wishlistbar").removeClass("active");
      }, 4000);
      $(".add-wishlist").show();
      $(".remove-wishlist").hide();
      setTimeout(function () {
        function swymCallbackFn() {
          window._swat.fetch(function (r) {
            if (r.length > 0) {
              $(".favorite-header").addClass("active");
            } else {
              $(".favorite-header").removeClass("active");
            }
          });
        }
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(swymCallbackFn);
      }, 1000);
    }
  );
  swat.evtLayer.addEventListener(
    swat.JSEvents.removedFromWishlist,
    function (event) {
      $(".add-wishlist").hide();
      $(".wishlistbar").addClass("active");
      setTimeout(function () {
        $(".wishlistbar").removeClass("active");
      }, 4000);
      $(".remove-wishlist").show();
      setTimeout(function () {
        function swymCallbackFn() {
          window._swat.fetch(function (r) {
            if (r.length > 0) {
              $(".favorite-header").addClass("active");
            } else {
              $(".favorite-header").removeClass("active");
            }
          });
        }
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(swymCallbackFn);
      }, 1000);
    }
  );
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
// $(".m-choose-selector a").on("click", function (e) {
//   e.preventDefault();
//   opensizemob();
// });
$(".pdp-msticky-overlay").on("click", function (e) {
  closesizemob();
});

function uspcountry(response) {
  let country_name = response.country_name;
  let all_coutry_list = [];
  let new_alllist = "";
  $(".usp-country").each(function (e) {
    let eachcountry = $(this).data("country");
    if (eachcountry.indexOf(country_name) != -1) {
      $(this).addClass("active");
    }
    new_alllist += eachcountry + ",";
  });
  let currency_rate = Shopify.currency.rate;
  if (new_alllist.indexOf(country_name) != -1) {
    let uspshipprice = $(".usp-country.active").data("price");
    uspshipprice = uspshipprice * currency_rate;
    $(".ups_shipprice").html(money_format(uspshipprice, shop_curr));
     if(country_name == 'Netherlands'){
       country_name = 'The Netherlands'
    }
    $(".ups_name_country").text(country_name);
    if ($(".usp-country.active").data("price") == 0) {
      $(".overtext,.ups_shipprice").hide();
    }
  } else {
    let uspshipprice = $(".usp-other-country").data("price");
    uspshipprice = uspshipprice * currency_rate;
    $(".ups_shipprice").html(money_format(uspshipprice, shop_curr));
     if(country_name == 'Netherlands'){
       country_name = 'The Netherlands'
    }
    $(".ups_name_country").text(country_name);
    if ($(".usp-other-country").data("price") == 0) {
      $(".overtext,.ups_shipprice").hide();
    }
  }
}
_ipgeolocation.getGeolocation(uspcountry, "ae3dd081993248b095346222d266ab88");
if ($(window).width() < 992) {
  $(".pro-medialoop").on("click", function (e) {
    $(".zoombutton").trigger("click");
  });
}
/*$('.mobile-sticky-product').bind('swipeup', openpdpbox);
function openpdpbox(event) {
  $('.sp-bottom-variants').slideDown();
  $('body').addClass('mob-open-size');    
}*/
$(".mobile-sticky-product").bind("swipedown", closepdpbox);
function closepdpbox(event) {
  closesizemob();
}
$(document).on("touchmove", ".stickytoppdpd:not(.temppdp)", function (e) {
  e.preventDefault();
  // opensizemob();
});
// $(".mobile-sticky-product").css(
//   "transform",
//   "translateY(" + $(".sp-bottom").outerHeight() + "px)"
// );
$(window).on("load", function (e) {
  setTimeout(function e(params) {
    $("body").addClass("load-pdp");
  }, 500);
});
// function opensizemob() {
//   if (!$("body").hasClass("mob-open-size")) {
//     $("body").addClass("mob-open-size");
//     $(".stickytoppdpd").addClass("temppdp");
//     //$('.sp-bottom').slideDown();
//     $(".first_display_pdp").addClass("active");
//     $(".mobile-sticky-product").css("transform", "translateY(0)");
//   }
// }
function closesizemob() {
  if ($("body").hasClass("mob-open-size")) {
    $("body").removeClass("mob-open-size");
    setTimeout(function () {
      $(".stickytoppdpd").removeClass("temppdp");
    }, 1000);
    //$('.sp-bottom').slideUp();
    setTimeout(function () {
      $(".first_display_pdp").removeClass("active");
    }, 0);
    // $(".mobile-sticky-product").css(
    //   "transform",
    //   "translateY(" + $(".sp-bottom").outerHeight() + "px)"
    // );
  }
}

// var skuId = meta.product.id;
// var s = document.createElement("script");
// s.type = "text/javascript";
// s.async = true;
// s.src =
//   "https://cdn.pixibo.com/fyf/production/lazy.js?clientid=d77d4b15fb4b&language=en&skuid=" +
//   skuId;
// var x = document.getElementsByTagName("script")[0];
// x.parentNode.insertBefore(s, x);



$('.variant--list li').on('click',function(e){
  if ($(this).hasClass('mobile-click')) {
    $('.almost-sold-out').removeClass('opa')
  }else(
    $('.almost-sold-out').addClass('opa')
  )
})
$('.soldout-variantlist.mobile-click').on('click',function(e){
  $('.almost-sold-out').addClass('opa')
})

document.addEventListener("DOMContentLoaded", function() {
  var productFormInstallment = document.querySelector('#product-form-installment .only-one-size');
  if (productFormInstallment && productFormInstallment.classList.contains('only-one-size')) {
    var radioButtons = document.querySelectorAll(".variant--list input[type='radio']");
    radioButtons.forEach(function(radioButton) {
      radioButton.click();
    });
  }
});

function checkWindowSize() {
  if (window.innerWidth < 992) {
    var sizeChartWithWishlist = document.querySelector('.sizechart-with-wishlist');
    var mobSizeChartWithWishlist = document.querySelector('.mob-sizechart-with-wishlist');
    if (sizeChartWithWishlist && mobSizeChartWithWishlist) {
        mobSizeChartWithWishlist.parentNode.insertBefore(sizeChartWithWishlist, mobSizeChartWithWishlist);
    }
  }
}

checkWindowSize();
window.addEventListener('resize', checkWindowSize);

// START A/B TEST HORIZONTAL SCROLL //


function adjustLayoutForSingleItem() {
  const totalItems = document.querySelectorAll('.product-dots li').length;
  const productDots = document.querySelector('.product-dots');
  const mediaItems = document.querySelectorAll('.pro-medialoop');

  if (totalItems === 1) {
    if (productDots) {
      productDots.style.display = 'none';
    }
    mediaItems.forEach(item => {
      item.style.margin = '0 auto';
    });
    
  } else {
    if (productDots) {
      productDots.style.display = 'flex';
    }
  }
}

document.addEventListener('DOMContentLoaded', adjustLayoutForSingleItem);

const mediaLoops = document.querySelectorAll('.pro-medialoop');
mediaLoops.forEach(mediaLoop => {
  mediaLoop.addEventListener('click', function() {
    const elementId = this.id;

    if (elementId) {
      window.location.hash = elementId.startsWith('#') ? elementId : `#${elementId}`;
    }
  });
});

function adjustImageHeight() {
  if (window.innerWidth < 991) {
    const sectionHeader = document.querySelector('.section-header');
    const mobileStickyProduct = document.querySelector('.mobile-sticky-product');
    const images = document.querySelectorAll('.inner-media .pro-medialoop');

    if (sectionHeader && mobileStickyProduct && images.length > 0) {
      const sectionHeaderBottom = sectionHeader.getBoundingClientRect().bottom;
      const mobileStickyProductTop = mobileStickyProduct.getBoundingClientRect().top;
      const availableHeight = mobileStickyProductTop - sectionHeaderBottom;

      images.forEach(div => {
        div.style.setProperty('height', `${availableHeight}px`, 'important');
      });
    }
  } else {
    // Reset the height for larger screens if needed
    document.querySelectorAll('.inner-media .pro-medialoop').forEach(div => {
      div.style.height = ''; // Reset to default
    });
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', adjustImageHeight);



// Run on window resize
function handleResize() {
  adjustImageHeight();
  window.removeEventListener('resize', handleResize); // Remove the listener after the first call
}

window.addEventListener('resize', handleResize);

document.addEventListener('DOMContentLoaded', function() {
  function initializeFlickity() {
    var flkty = new Flickity('.promedialist', {
      freeScroll: true,
      imagesLoaded: true,
      lazyLoad: true,
      wrapAround: true,
      pageDots: true,
      accessibility: true,
      cellAlign: window.innerWidth > 768 ? 'left' : 'center',
      draggable: window.innerWidth <= 768
    });
  }

  // Initialize Flickity on page load
  initializeFlickity();

  // Reinitialize Flickity on window resize
  window.addEventListener('resize', function() {
    // Debounce resize function for performance
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function() {
      initializeFlickity();
    }, 250);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const nextArrow = document.getElementById('nextArrow');
  const prevArrow = document.getElementById('previousArrow');
  
  const flickityNextButton = document.querySelector('.promedialist .flickity-button.flickity-prev-next-button.next');
  const flickityPrevButton = document.querySelector('.promedialist .flickity-button.flickity-prev-next-button.previous');

  if (nextArrow && flickityNextButton) {
    nextArrow.addEventListener('click', function() {
      flickityNextButton.click();
    });
  }

  if (prevArrow && flickityPrevButton) {
    prevArrow.addEventListener('click', function() {
      flickityPrevButton.click();
    });
  }
});


// END A/B TEST HORIZONTAL SCROLL //